import React from 'react';
import ReactInputMask from 'react-input-mask';

const InputFieldWrapper = React.forwardRef(({ masking, maxLength, ...props }, ref) => {
  // If masking is true, exclude the maxLength property to avoid the warning
  const inputProps = masking ? { ...props } : { maxLength, ...props };

  if (masking) {
    return <ReactInputMask {...inputProps} inputRef={ref} />;
  }

  return <input ref={ref} {...inputProps} />;
});

InputFieldWrapper.displayName = "InputFieldWrapper";

export default InputFieldWrapper;
